/* Uncomment next line to activate HttpClient debugging (logs) */
import {
  HttpClientModule
  /* HTTP_INTERCEPTORS */
} from '@angular/common/http';
import { ErrorHandler, NgModule } from '@angular/core';
import { AngularFireModule } from '@angular/fire/compat';
import {
  AngularFireAuthModule
  /* PERSISTENCE */
} from '@angular/fire/compat/auth';
import { AngularFireDatabaseModule } from '@angular/fire/compat/database';
import { AngularFirestoreModule } from '@angular/fire/compat/firestore';
import { AngularFireFunctionsModule } from '@angular/fire/compat/functions';
import { AngularFireStorageModule } from '@angular/fire/compat/storage';
import { BrowserModule, Title } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { IonicModule } from '@ionic/angular';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { BsModalService, ModalModule } from 'ngx-bootstrap/modal';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { PERFECT_SCROLLBAR_CONFIG } from 'ngx-perfect-scrollbar';
import { ToastrModule } from 'ngx-toastr';
import { OneSignal } from 'onesignal-ngx';

import { environment, firebaseApiKey } from '../environments/environment';

import { AppRoutingModule } from './app-routing.module';
import { SharedModule } from './shared/shared.module';

import { RollbarErrorHandler, rollbarFactory, RollbarService } from './shared/services/rollbar/rollbar.service';

import { AppComponent } from './app.component';
import { LoginComponent } from './login/login.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { ToastComponent } from './shared/components/toast/toast.component';
import { ClickStopPropagationDirective } from './shared/ui-elements/directives/click-stop-propagation.directive';
import { ClickPreventDefaultDirective } from './shared/ui-elements/directives/clicl-prevent-default.directive';

@NgModule({
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AngularFireModule.initializeApp({ ...environment.firebase, apiKey: firebaseApiKey }),
    AngularFireDatabaseModule,
    AngularFirestoreModule,
    AngularFireAuthModule,
    AngularFireFunctionsModule,
    AngularFireStorageModule,
    ModalModule.forRoot(),
    BsDropdownModule.forRoot(),
    PopoverModule.forRoot(),
    SharedModule,
    AppRoutingModule,
    ToastrModule.forRoot({
      timeOut: 4000,
      progressBar: true,
      closeButton: true,
      toastComponent: ToastComponent
    }),
    IonicModule.forRoot({
      platform: {
        /** The default `desktop` function returns false for devices with a touchscreen.
         * This is not always wanted, so this function tests the User Agent instead.
         **/
        desktop: win => {
          const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(win.navigator.userAgent);
          return !isMobile;
        }
      }
    })
  ],
  declarations: [AppComponent, LoginComponent, PageNotFoundComponent, ClickStopPropagationDirective, ClickPreventDefaultDirective, ToastComponent],
  providers: [
    BsModalService,
    { provide: ErrorHandler, useClass: RollbarErrorHandler },
    { provide: RollbarService, useFactory: rollbarFactory },
    {
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: {
        suppressScrollX: true
      }
    },
    // { provide: PERSISTENCE, useValue: 'session' },
    Title,
    OneSignal
    /* Uncomment next line to activate HttpClient debugging (logs) */
    // { provide: HTTP_INTERCEPTORS, useClass: HttpLoggerService, multi: true },
  ],
  bootstrap: [AppComponent],
  exports: []
})
export class AppModule {}
